angular.module('impactx.item', []).controller('ItemCtrl', ['$scope', 'ColorUtilService', 'AppConfiguration', function ($scope, ColorUtilService, AppConfiguration) {
    $scope.showBuyerNoMinimizedBasket = AppConfiguration.get('showBuyerNoMinimizedBasket');
    $scope.offSetForSelectColor = 6;
    $scope.offSetForBasketMandatoryColor = 12;
    $scope.offSetForBasketItemGroupColor = 15;
    $scope.selectItem = function (item, event) {
        if (event.target.tagName != "INPUT" && (event.target.parentNode == null || event.target.parentNode.tagName != "BUTTON")
            && event.target.tagName != "BUTTON" && event.target.tagName != "TEXTAREA"
            && event.target.tagName != "MD-SELECT"
            && event.target.getAttribute("role") != "button") {
            if ($scope.showComments) {
                $scope.showComments.value = false;
            }
            if ($scope.showChange) {
                $scope.showChange.value = false;
            }
            if ($scope.selectedSupplier) {
                $scope.selectedSupplier.splice(0, 1);
            }
            if ($scope.selectedOtherItems) {
                for (var i = 0; i < $scope.selectedOtherItems.length; i++) {
                    $scope.selectedOtherItems[i].selected = false;
                }
                $scope.selectedOtherItems.splice(0, 1);
            }
            if (item.selected) {
                var index = $scope.selectedItems.indexOf(item);
                if (index > -1) {
                    $scope.selectedItems.splice(index, 1);
                }
            }
            else {
                $scope.selectedItems.push(item);
            }
            item.selected = !item.selected;
        }
    };

    $scope.deleteItemSelection = function () {
        for (var i = 0; i < $scope.selectedItems.length; i++) {
            $scope.selectedItems[i].selected = false;
        }
        $scope.selectedItems = [];
    };

    if ($scope.item.infoGroup) {
        var color = ColorUtilService.getColor($scope.item.infoGroup);
        $scope.color = {'border-left-color': color};
    }
    else {
        $scope.color = {'border-left-color': 'transparent'};
    }

    if ($scope.item.selectGroup) {
        var color = ColorUtilService.getColor($scope.item.selectGroup + $scope.offSetForSelectColor);
        $scope.colorSelect = {'border-left-color': color};
    }
    else {
        $scope.colorSelect = {'border-left-color': 'transparent'};
    }

    if ($scope.item.basketMandatoryGroup) {
        var color = ColorUtilService.getColor($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor);
        $scope.colorBasketMandatory = {'border-left-color': color};
    }
    else {
        $scope.colorBasketMandatory = {'border-left-color': 'transparent'};
    }

    if ($scope.item.basketItemGroupId) {
        var color = ColorUtilService.getColor($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor);
        $scope.colorBasketItemGroup = {'border-left-color': color};
    }
    else {
        $scope.colorBasketItemGroup = {'border-left-color': 'transparent'};
    }

    $scope.extendBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.item.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorder = function () {
        var element = document.getElementsByClassName('basket-item-' + $scope.item.infoGroup);
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderSelect = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderSelect = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.selectGroup + $scope.offSetForSelectColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };
    $scope.extendBorderBasketMandatory = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketMandatory = function() {
        var element = document.getElementsByClassName('basket-item-' + ($scope.item.basketMandatoryGroup + $scope.offSetForBasketMandatoryColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function(aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.extendBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    $scope.shrinkBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    $scope.eClassDataArray = [{field: "eClass", value: $scope.item.eClass}, {
        field: "sapConfigId",
        value: $scope.item.sapConfigId
    }];

    $scope.getOrderConfirmationLink = function (pohId) {
        if (impactX.isDefined($scope, "$parent.isSupplier")) {
            return "#/orderconfirmationsupplier/" + pohId;
        }
        else {
            return "#/orderconfirmationbuyer/" + pohId;
        }
    };
}
])
    .directive('appItem', [function () {
        return {
            scope: {
                item: '=',
                selectedItems: '=',
                trns: '=',
                showNet: "=",
                showGross: "=",
                showComments: "=",
                showChange: "=",
                showDates: "=",
                selectedOtherItems: "=",
                showCatalogNet: "=",
                readOnly: "=",
                minimized: "=?",
                pohId: "=?",
                isSupplier: "=?",
                redirectApprovalFunc: "&?"
            },
            restrict: 'E',
            templateUrl: 'shared/item/item.html',
            transclude: true
        };
    }
    ]);